const viewMoreElement = document.querySelector('.js-btn-load-more');
const options = {
  root: null, // default, uses the document's viewport
  rootMargin: '600px',
  threshold: 0.0 // trigger as soon as a pixel enters the rootMargin area
};

if (viewMoreElement) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
          viewMoreElement.click();
          variantsPicker();
          setTimeout(() => {
            variantsPicker();
          }, 500);
          setTimeout(() => {
            variantsPicker();
          }, 1000);
          setTimeout(() => {
            variantsPicker();
          }, 1500);
        }
    });
  });
  observer.observe(viewMoreElement, options);
}
